// Removes `?token=...` from the current URL via history.replaceState
// before any other code runs. Magic-link tokens are single-use and
// short-lived, but we don't want them captured by future RUM session
// replay or accidentally included in client-side error reports.
//
// Defense in depth — the RUM `beforeSend` hook in `datadog-rum.ts`
// also redacts captured URLs.
export function stripTokenFromUrl(): void {
  if (typeof window === "undefined") {
    return;
  }
  if (typeof window.history?.replaceState !== "function") {
    return;
  }
  const url = new URL(window.location.href);
  if (!url.searchParams.has("token")) {
    return;
  }
  url.searchParams.delete("token");
  window.history.replaceState({}, "", url.toString());
}
